import React from "react";
import { gql, useQuery } from "@apollo/client";
import "./Console.css";

const GET_SITE_STATUSES = gql`
  query GetSiteStatuses { siteStatuses { id name nodesTotal nodesOnline eventsToday } }
`;

function dotClass(s: any) {
  if (s.nodesTotal === 0) return "con-dot-none";
  if (s.nodesOnline === 0) return "con-dot-down";
  if (s.nodesOnline < s.nodesTotal) return "con-dot-part";
  return "con-dot-up";
}

export default function Console() {
  const { data, loading, refetch } = useQuery(GET_SITE_STATUSES, { pollInterval: 10000 });
  const sites = data?.siteStatuses || [];

  const online = sites.filter((s: any) => s.nodesTotal > 0 && s.nodesOnline === s.nodesTotal).length;
  const degraded = sites.filter((s: any) => s.nodesTotal > 0 && s.nodesOnline < s.nodesTotal).length;

  return (
    <div className="page-container">
      <div className="page-header">
        <h2>🛰 Objects Console</h2>
        <button className="con-refresh" onClick={() => refetch()}>↻ Refresh</button>
      </div>

      <div className="con-summary">
        <div className="con-sum"><b>{sites.length}</b> objects</div>
        <div className="con-sum con-ok"><b>{online}</b> fully online</div>
        <div className="con-sum con-warn"><b>{degraded}</b> degraded</div>
      </div>

      {loading && <div className="con-empty">Loading…</div>}
      {!loading && sites.length === 0 && <div className="con-empty">No objects yet.</div>}

      <div className="con-grid">
        {sites.map((s: any) => (
          <div key={s.id} className="con-card">
            <div className="con-head">
              <span className={"con-dot " + dotClass(s)} />
              <span className="con-name">{s.name}</span>
            </div>
            <div className="con-row"><span>Nodes online</span><b>{s.nodesOnline}/{s.nodesTotal}</b></div>
            <div className="con-row"><span>Events today</span><b>{s.eventsToday}</b></div>
          </div>
        ))}
      </div>
    </div>
  );
}
